module.exports = __webpack_public_path__ + "static/media/udc.a2716f2e.webp";